import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import Contact from '../components/Contact';
import ContactForm from '../components/ContactForm';
import VolunteerForm from '../components/VolunteerForm';
import './ContactPage.css';

const ContactPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="contact-page">
      <div className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <h1 className="page-title">
              {t.contactTitle}
            </h1>
            <p className="page-subtitle">
              {t.contactIntro}
            </p>
          </div>
        </div>
      </div>
      
      <Contact />
      
      {/* Forms Section */}
      <div className="forms-section">
        <div className="container">
          <div className="forms-grid">
            <ContactForm />
            <VolunteerForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
